import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowUp } from '@fortawesome/pro-solid-svg-icons';

export default function Placeholder() {
  return (
    <React.Fragment>
      <FontAwesomeIcon icon={faFileArrowUp} size="3x" />
      <h6>Upload Files</h6>
      <div className="text-muted">Click or drag files or folders here to upload them</div>
    </React.Fragment>
  );
}
